import { IPalette } from 'office-ui-fabric-react'
import { ThemeProps } from './types'

export const themeColor =
  <T extends ThemeProps = ThemeProps>(
    selector: ((palette: IPalette) => string) | keyof IPalette
  ) =>
  ({ theme }: T) =>
    typeof selector === 'function'
      ? selector(theme!.palette)
      : theme!.palette[selector]
